/** Height we reserve beneath the sticky header when jumping to a #section so
 * that the section's title isn't swallowed. Keep in sync with .ek-anchor CSS. */
export const HEADER_OFFSET = 92;

export function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  // Fluid layout stays sticky too; we use scroll-margin via CSS, but Safari
  // iOS doesn't always honour it for programmatic scrollIntoView. Fallback:
  const rect = el.getBoundingClientRect();
  const target = window.scrollY + rect.top - (id === 'home' ? 0 : HEADER_OFFSET);
  try {
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  } catch {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export const isConfigured = (url?: string) => !!url && url.trim().length > 0;
